/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

if($('body').hasClass('template--collection')){
  console.log('test');
  // INFINITE COLLECTION
  var pInfScrLoading = false;
  var pInfScrDelay = 100;
  
  function pInfScrExecute() {
    if( $('product-list.product-facet__product-list').height() - 400 < $(document).scrollTop()) {
      var loadingImage;
      pInfScrNode = $('.product-list__inner.grid_view_custom').find('.more');
      
      if(!pInfScrLoading && pInfScrNode.length > 0) {
        pInfScrURL = pInfScrNode.find('a').attr("href");  
        $('.product-list__inner.grid_view_custom').find('.more').remove();
        $('.product-list').append('<img src="https://cdn.shopify.com/s/files/1/1587/9445/files/Spinner-2.gif?v=1770272241" class="infinite-scroll-loader scroll_loading" />');
        $.ajax({
          type: 'GET',
          url: pInfScrURL,
          beforeSend: function() {
            pInfScrLoading = true;
            loadingImage = pInfScrNode.clone().empty().append('');
            loadingImage.insertAfter(pInfScrNode);
            pInfScrNode.hide();
            
            console.log('loading...');
          },
          success: function(data) {
            // remove loading feedback
            pInfScrNode.next().remove();
            var filteredData = $(data).find(".product-list__inner");
            $('.product-list__inner.grid_view_custom').append(filteredData.html());
            
            loadingImage.remove();	              
            $('.product-list').find('.scroll_loading').remove();
            pInfScrLoading = false;
            document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
          },
          dataType: "html"
        });
      }
    }
  }
  $(document).ready(function () {
    $(window).scroll(function(){
      $.doTimeout( 'scroll', pInfScrDelay, pInfScrExecute);
      // if( $(document).height() - 800 > $(document).scrollTop() + $(window).height() ) {
      if( $('product-list.product-facet__product-list').height() - 400 < $(document).scrollTop()) {
        pInfScrDelay = 20;
      }
    });
  });
}

$(document).ready(function() {

   $(".customer-testimonial-blocks").slick({
      arrows:false,
      dots: true,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $(".visit-our-stores-blocks").slick({
      arrows:false,
      dots: true,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $('body').on('click','.product-list_view-toggle', function(e) {
    e.preventDefault();
    $('.product-list_view-toggle').removeClass('active');
    $(this).addClass('active');
    $("product-list").attr("list-type", $(this).attr('href'));
  })

  const storeLocator = document.querySelector(".store-locator-iner");
  if (storeLocator) {
    const tabs = document.querySelectorAll(".store-locator__tabs .tab");
    const storeItems = document.querySelectorAll(".store-item");
    const searchInput = document.getElementById("storeSearch");
    const backBtn = document.querySelector(".sld-back-btn");
    const backBtntext = document.querySelector(".sld-back-btn-text");
    const locatorDetail = document.querySelector(".store-locator-detail");
    const detailCards = document.querySelectorAll(".store-locator-detail-blocks");
    const backbtnWrap = document.querySelector(".sld-back-btn-wrap");
    const searchClosebtn = document.querySelector(".store-loc-input-btn");
    locatorDetail.setAttribute("hidden", "");
    let type = "city"; // default tab
    // Tab switching
    tabs.forEach(tab => {
      tab.addEventListener("click", () => {
        tabs.forEach(t => t.classList.remove("active"));
        tab.classList.add("active");        
        type = tab.dataset.tab;
        searchClosebtn.setAttribute("data-toggle",type);
        const backBtntext = backBtn.innerText;
        if (type === "city") {
          backBtntext.textContent = "Back to all cities";
        } else {
          backBtntext.textContent = "Back to all states";
        }
        filterStores(); // refresh when switching
      });
    });
    // Search filter
    if (searchInput) {
      searchInput.addEventListener("keyup", function () {
        filterStores();
      });
    }

    function filterStores() {
    const value = searchInput.value.toLowerCase().trim();
    const hasSearch = value !== "";

    console.log("search value:", value);    

      // 1️⃣ CITY/STATE LIST FILTER
      storeItems.forEach(item => {
        const matchCity = item.dataset.city?.toLowerCase().includes(value);
        const matchState = item.dataset.state?.toLowerCase().includes(value);

        if (!hasSearch) {
          // No search → show according to active tab
          locatorDetail.setAttribute("hidden", "");
          backbtnWrap.setAttribute("hidden", "");        
          if (type === "city" && item.dataset.city) {
            item.style.display = "block";
          } else if (type === "state" && item.dataset.state) {
            item.style.display = "block";
          } else {
            item.style.display = "none";
          }
        } else {
          // Searching → match both city/state
          if (matchCity || matchState) {
            item.style.display = "block";
          } else {
            item.style.display = "none";
          }
        }
      });

      // 2️⃣ DETAIL CARDS MATCHING
      let detailMatchFound = false;

      detailCards.forEach(card => {
        const detailMatch =
          card.dataset.detail?.toLowerCase().includes(value) ||
          card.dataset.area?.toLowerCase().includes(value);

        if (hasSearch && detailMatch) {
          card.removeAttribute("hidden");
          detailMatchFound = true;
        } else {
          card.setAttribute("hidden", "");
        }
      });

      // 3️⃣ SHOW/HIDE DETAIL WRAPPER
      if (hasSearch && detailMatchFound) {
        locatorDetail.removeAttribute("hidden");
        backbtnWrap.setAttribute("hidden", "");
        searchClosebtn.style.opacity = "1";
      } else {
        locatorDetail.setAttribute("hidden", "");
        backbtnWrap.removeAttribute("hidden");
        searchClosebtn.style.opacity = "0";
      }
    }

    // Initial load
    filterStores();    
    const locatorList = document.querySelector(".store-locator__list");    
    const locatorTabs = document.querySelector(".store-locator__tabs");      
    storeItems.forEach(item => {
      item.addEventListener("click", () => {
        const itemCity = item.dataset.city;
        const itemState = item.dataset.state;
        console.log('itemCity',itemCity)
        console.log('itemState',itemState)
        locatorList.setAttribute("hidden", "");
        locatorTabs.setAttribute("hidden", "");
        locatorDetail.removeAttribute("hidden");
        detailCards.forEach(card => {
          const blockcity = card.dataset.detail;
          if (card.dataset.detail === itemCity) {
            card.removeAttribute("hidden");
          }
          else if (card.dataset.detail === itemState) {
            card.removeAttribute("hidden");
          } else {
            card.setAttribute("hidden", "");
          }
        })
      });
    });
    backBtn.addEventListener("click", () => {
      locatorList.removeAttribute("hidden");
      locatorTabs.removeAttribute("hidden");
      locatorDetail.setAttribute("hidden", "");
    })
    document.querySelector(".store-loc-input-btn").addEventListener("click", function() {
      const tabName = this.dataset.toggle;
      this.style.opacity = "0";
      document.getElementById("storeSearch").value = "";
      locatorList.removeAttribute("hidden");
      locatorTabs.removeAttribute("hidden");
      locatorDetail.setAttribute("hidden", "");
      storeItems.forEach(itemm => {
        console.log(itemm.dataset.city);        
        if (tabName === "city" && itemm.dataset.city) {
          itemm.style.display = "block";
        }else if (tabName === "state" && itemm.dataset.state) {
          itemm.style.display = "block";
        } else {
          itemm.style.display = "none";
        }
      })
    });
  }


  // DELIVERY TIMELINE
  const deliveryTime = document.querySelector(".pf-delivery-timeline-wrap");
  if (deliveryTime) {
    function formatDate(date) {
      const options = { month: "short", day: "numeric" };
      return date.toLocaleDateString("en-US", options);
    }
    function addDays(date, days) {
      const result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    }
    const today = new Date();
    // Order placed = today
    document.getElementById("pf-dt-order-1").textContent = formatDate(today);
    // Order shipped = +2 to +3 days range
    const shipStart = addDays(today, 2);
    const shipEnd = addDays(today, 3);
    document.getElementById("pf-dt-order-2").textContent =
      `${formatDate(shipStart)}-${formatDate(shipEnd)}`;
    // Estimated delivery = +2 to +3 days after shipping
    const deliveryStart = addDays(shipEnd, 2);
    const deliveryEnd = addDays(shipEnd, 3);
    document.getElementById("pf-dt-order-3").textContent =
      `${formatDate(deliveryStart)}-${formatDate(deliveryEnd)}`;
  }  

  const headerSearch = document.querySelector(".header-desktop-search-bar-inr .predictive-search__input");
  const $html = document.querySelector("html");
  if (headerSearch) {
    headerSearch.addEventListener("keyup", function (e) {   
      let value = e.target.value.trim();     
      if (value === "") {
        $html.classList.remove("lock-all");
      } else {
        $html.classList.add("lock-all");
      }
    });
  }

  // REMOVE SEARCH INPUT ON CLICK
  $("body").on("click",".pre-search-input-clear", function (){
    const $wrapper = $(this).closest(".predictive-search-secondary");
    const searchWrap = $wrapper.find(".predictive-search__results");
    const searchFooter = $wrapper.find(".drawer__footer");
    console.log('searchFooter',searchFooter);
    searchWrap.attr("hidden", "hidden");
    searchFooter.attr("hidden", "hidden");
    $(this).siblings('.predictive-search__input').val('');
    $("html").removeClass("lock-all");
  })


  const width = window.outerWidth;  
  if (width <= 999) {
    const footerToggles = document.querySelectorAll(".mobile-footer-item-title");
     footerToggles.forEach(footerToggle => {
      footerToggle.addEventListener("click", () => {
        footerToggle.classList.toggle('active');
        const ft_content = footerToggle.nextElementSibling;
        ft_content.classList.toggle('active');
      });
    });

    // PRODUCT CONTENT MOBILE ACCORDIAN
    const productTabs = document.querySelectorAll(".product-tabs__tab-item-wrapper");    
    productTabs.forEach(productTab => {
      const tab_buttons = productTab.querySelector("button");
      tab_buttons.setAttribute("aria-expanded", "false");
    })
  } 

})